import { render, staticRenderFns } from "./click_to_copy.vue?vue&type=template&id=15d2ac41&"
import script from "./click_to_copy.vue?vue&type=script&lang=js&"
export * from "./click_to_copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports